module.exports = __webpack_public_path__ + "static/media/Zhiffy.656826a0.png";